import { render } from "./NewProduct.vue?vue&type=template&id=692d39f0&bindings={}"
import script from "./NewProduct.vue?vue&type=script&lang=ts"
export * from "./NewProduct.vue?vue&type=script&lang=ts"

import "./NewProduct.vue?vue&type=style&index=0&lang=less"
script.render = render

export default script